export default "__VITE_ASSET__BiFnzew1__"